import React from "react";
import PageHeader from "../components/ui/PageHeader";
import EmptyState from "../components/ui/EmptyState";

/**
 * Generic placeholder for nav items that have a real route (no 404) but no
 * backend yet. Per the redesign brief: "mock-safe UI structures... no fake
 * permanent data stored as real records." Each instance is configured below
 * in PLACEHOLDER_PAGES and rendered via App.js routes.
 */
const ComingSoon = ({ title, subtitle, icon, description, todo }) => (
  <div className="max-w-3xl space-y-6">
    <PageHeader title={title} subtitle={subtitle} />
    <div className="card-celestial rounded-2xl">
      <EmptyState
        icon={icon}
        title="This page is wired up, but the backend isn't there yet."
        description={description}
        isComingSoon
      />
    </div>
    {todo && (
      <div className="text-xs text-celestial-muted/60 font-mono px-1">
        TODO: {todo}
      </div>
    )}
  </div>
);

export default ComingSoon;
